import React from 'react'
import { Container, Typography } from '@cleartrip/ct-design-components'
import { SectionDefinition, SECTIONS, SectionId } from './constants'
import styles from './VdcEducationPage.module.scss'

interface SidebarItemProps {
  section: SectionDefinition
  isActive: boolean
  onClick: () => void
}

const SidebarItem: React.FC<SidebarItemProps> = ({ section, isActive, onClick }) => (
  <Container className={`${styles.sidebarItem} c-pointer flex flex-middle`} onClick={onClick}>
    <span className={`${styles['sidebarItem__indicator']} ${isActive ? styles['sidebarItem__indicator--active'] : styles['sidebarItem__indicator--inactive']}`} />
    <Typography variant="P2" className={`${styles['sidebarItem__label']} ${isActive ? styles['sidebarItem__label--active'] : styles['sidebarItem__label--inactive']}`}>
      {section.label}
    </Typography>
  </Container>
)

interface SidebarProps {
  activeSection: SectionId
  onSectionClick: (sectionId: SectionId) => void
}

const Sidebar: React.FC<SidebarProps> = ({ activeSection, onSectionClick }) => (
  <Container className={`${styles.sidebar} flex flex-column`}>
    {SECTIONS.map((section, index) => (
      <React.Fragment key={section.id}>
        <SidebarItem 
          section={section} 
          isActive={activeSection === section.id} 
          onClick={() => onSectionClick(section.id)} 
        />
        {index < SECTIONS.length - 1 && <div className={styles['sidebar__divider']} />}
      </React.Fragment>
    ))}
  </Container>
)

export default Sidebar

